"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Remove = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Remove = function () { return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M0 12C0 5.373 5.373 0 12 0a12 12 0 0112 12c0 6.627-5.373 12-12 12S0 18.627 0 12zm7.2.6a.6.6 0 00.6.6h8.4a.6.6 0 00.6-.6v-1.2a.6.6 0 00-.6-.6H7.8a.6.6 0 00-.6.6v1.2z", clipRule: "evenodd" })); };
exports.Remove = Remove;
//# sourceMappingURL=remove.js.map